import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.573 12.914l-4.573 -9.914l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}],["path",{"d":"M19 16v6","key":"svg-2"}]]

const IconNavigationPlus = createReactComponent('outline', 'navigation-plus', 'NavigationPlus', __iconNode);

export default IconNavigationPlus;